import axios from 'axios'

import { setFullName, parseResponse, handleError } from '@/_helpers/utils.js'

const state = {
  loading: true,
  error: null,
  list: [],
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    load_more_pages: 1,
    is_load_more: false,
    count: 20
  },
  sorting: {
    name: null,
    order: 'asc'
  }
}

const actions = {
  fetch ({commit, state, dispatch}, filters) {
    commit('fetch')

    let params = {}
    const sorting = state.sorting

    if (sorting.name) {
      Object.assign(params, {
        sort_by: sorting.name,
        sort_order: sorting.order
      })
    }    

    let count = state.pagination.count;
    const is_load_more = state.pagination.is_load_more;
    if (is_load_more) {
      count = (state.pagination.pageNumber * state.list.length) + state.pagination.count

      params.page = 1;
      params.count = count
    } else {
      if (!filters || filters.count === undefined) {
        params.count = state.pagination.count;
        params.page = state.pagination.pageNumber
      } else if (filters.count) {
        params.count = filters.count;
        params.page = state.pagination.pageNumber
      }
    }

    if (filters && filters.is_personal_manager) {
      params.is_personal_manager = 1
    }

    return axios.get('/1.0/admin/users-admin', {params})
      .then(response => {
        const data = parseResponse(response);

        commit('fetchSuccess', {data: data.data, meta: data.meta, is_load_more});

        if (is_load_more) {
          commit('set_pagination_more', {count})
        }
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  updateSorting ({ commit, state, dispatch }, data) {
    commit('updateSorting', data)
  },

  updateFilters ({commit, state, dispatch}, data) {
    commit('updateFilters', data)
    dispatch('fetch')
  },

  clear ({commit, state, dispatch}) {
    commit('resetPagination')
    commit('clear')
  },

  createRecruiter ({ commit, state, dispatch }, data) {
    return axios.post('/1.0/admin/recruiters', {recruiters: [data]})
      .then(response => {
        return parseResponse(response).data[0]
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetchFailure', error);

        throw error;
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {data, meta, is_load_more}) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count)
    }

    const data_with_full_name = data.map(user => {
      return setFullName(user, 'first_name', 'last_name')
    })
    state.list = data_with_full_name
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  resetPagination (state) {
    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      load_more_pages: 1,
      is_load_more: false,
      count: 20
    })
  },

  clear (state) {
    state.list = []
  },

  set_load_more (state, val) {
    state.pagination = Object.assign(state.pagination, {
      is_load_more: val
    })
  },

  set_pagination_more (state, {count}) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count)
  },

  change_count (state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    })
  },

  updatePagination (state, params) {
    state.pagination = Object.assign(state.pagination, params)
  },

  updateSorting (state, data) {
    Object.assign(state.sorting, data)
  },

  updateFilters (state, data) {
    Object.assign(state.filters, data)
  }
}

const getters = {
  loading (state, getters) {
    return state.loading
  },

  get_list: (state, getters) => {
    return state.list
  },

  pagination: (state, getters) => {
    return state.pagination
  },

  sorting: (state, getters) => {
    return state.sorting
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
